import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    marginBottom: "1rem"
    // border: '1px solid blue'
  },
  mainIcon: {
    width: '35px !important',
    /* border: '1px solid red', padding: '10px',
    borderRadius: '100px' */
  },
}));
